import { dataContext } from "components/dataContext/dataContext";
import { AccountContext } from 'components/Account/Account';
import React, { useContext, useMemo, useState } from "react";
import '../assets/css/dataTable.css';
import downloadCSV from '../csv/downloadCSV';
import checkDocumentosCargados from 'api/checkDocumentosCargados';
import ContainerCheckDocsBDS3 from 'components/Container/ContainerCheckDocsBDS3';
import ContainerResultadosCheckDocsBDS3 from 'components/Container/ContainerResultadosCheckDocsBDS3';
import ModalCargando from 'components/Modal/ModalCargando';
import ModalError from 'components/Modal/ModalError';
import { Button } from "react-bootstrap";
import obj from "api/reprocesarfolios";

const CheckDocsBDS3 = () => {

  // console.log(' RR0 Lectura Constantes');

  const [startDate, setStartDate] = useState(new Date().toISOString().slice(0, 10));
  const { data } = useContext(dataContext);
  const { getSession } = useContext(AccountContext);
  const [showLoading, setShowLoading] = useState(false);
  const [modalTitleLoading, setModalTitleLoading] = useState('');
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showContainerCheckDocsBDS3] = useState(true);
  const [showContainerResultadosCheckDocsBDS3, setShowContainerResultadosCheckDocsBDS3] = useState(false);
  const [dataFiltered, setDataFiltered] = useState([]);
  const [filter, setFilter] = useState('');

  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const dataDisplayed = useMemo(() => {
    if (!filter) return dataFiltered;
    const term = filter.toLowerCase().trim();
    return dataFiltered.filter((row) => {
      return (
        (row.rut && String(row.rut).toLowerCase().includes(term)) ||
        (row.tipoDocumento && String(row.tipoDocumento).toLowerCase().includes(term))
      );
    });
  }, [dataFiltered, filter]);

  const stats = useMemo(() => {
    if (!dataFiltered.length) return null;
    let conDiferencia = 0;
    let totalDiferencias = 0;
    dataFiltered.forEach((r) => {
      const dif = toNum(r.diferencia);
      if (dif !== 0) conDiferencia += 1;
      totalDiferencias += Math.abs(dif);
    });
    return {
      empresas: dataFiltered.length,
      conDiferencia,
      totalDiferencias,
    };
  }, [dataFiltered]);

  const handleOnChangeFilterResultados = (e) => {
    setFilter(e.target.value);
  };



  // console.log(' RR3 Lectura errorMessages');

  const errorMessages = {
    400: '- Bad Request',
    401: '- Unauthorized',
    403: '- Forbidden',
    404: '- Not Found',
    500: '- Internal Server Error',
    502: '- Bad Gateway',
    503: '- Service Unavailable',
    504: '- Gateway Timeout'
  };

  // console.log(' RR4 Lectura busqueda');

  const busqueda = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const idToken = await getSession().then((session) => session.idToken.jwtToken);
    const fecha = startDate;

    try {
      setModalTitleLoading('C2C BOLETAS CLOUD');
      setLoadingMessage('Consultando datos...');
      setShowLoading(true);
      setLoadingDetail(true);
      let response = await checkDocumentosCargados(idToken, fecha);
      // console.log(response)
      console.log('Respuesta de la consulta:', response);
      setDataFiltered(response.data.empresas || []);
      setShowContainerResultadosCheckDocsBDS3(true);

    } catch (error) {
      console.log('Error en la consulta:', error);
      setShowLoading(false);
      setLoadingDetail(false);
      setModalTitleLoading('C2C BOLETAS CLOUD');
    }
    finally {
      setShowLoading(false);
      setLoadingDetail(false);
    }

  };

  // console.log(' RR5 Lectura dataCheck');



  // console.log(' RR6 Lectura resetModal');

  // const resetModal = () => {
  //   handleClose()
  // };

  // console.log(' RR7 Lectura handleClose');

  const handleClose = () => {
   setLoadingDetail(false);
   setShowLoading(false);
   setShowErrorModal(false);
   setErrorMessage('');
   // setShowContainerCheckDocsBDS3(true);
   // setShowContainerResultadosCheckDocsBDS3(false);
  };

  // console.log(' RR8 Lectura handleOnChangeFilter');

  const handleOnChangeFilter = (e) => {
    const newStartDate = e.target.value;
    if (newStartDate !== startDate) {
      setStartDate(newStartDate);
    }
  };

  // console.log(' RR9 Lectura actionsMemo');

  const actionsMemo = useMemo(
    () => ({
      onExport: () => {
        setShowLoading(true);
        setLoadingDetail(true);
        setModalTitleLoading('C2C BOLETAS CLOUD');
        setLoadingMessage('Exportando Datos...');
        const timestamp = new Date().toISOString().replace(/:/g, "-");
        const filename = `export_ResultadosCheckDocumentosBD/S3_${timestamp}.csv`;
        if (dataFiltered.length === 0) {
          setLoadingDetail(false);
          setModalTitleLoading('C2C BOLETAS CLOUD');
          setLoadingMessage('No hay datos para exportar');
        } else {
          downloadCSV(dataFiltered, filename);
          setLoadingDetail(false);
          setModalTitleLoading('C2C BOLETAS CLOUD');
          setLoadingMessage('Datos Exportados, documento generado: ' + filename);

        }
      }
    }),
    [dataFiltered]
  );
  const reprocesarfoliosfaltantes =
    async (row) => {
      console.log(row)
      try {
        setLoadingDetail(true);
        setModalTitleLoading('C2C BOLETAS CLOUD');
        setLoadingMessage('Reprocesando folios faltantes para rut: ' + row.rut);
        setShowLoading(true);
        const params = { fecha: startDate, rut: row.rut, rangoFolios: row.foliosNoCargadosEnBDCompress,tipoDocumento:row.tipoDocumento }
        const idToken = await getSession().then((session) => session.idToken.jwtToken);
        const resp= await obj.reprocesarfolios(params, idToken)
        setLoadingMessage(resp.data.message || 'Reprocesamiento completado para rut: ' + row.rut);
        setLoadingDetail(false);
        
      } catch (error) {
        console.log(error)
        setErrorMessage('Ocurrió un error al reprocesar los folios faltantes: ' + (errorMessages[error.status] || error.message));
        setShowErrorModal(true);

      }
      finally {
        // setLoadingDetail(false);
        // setShowLoading(false);

      }
    }

      // console.log(' RR10 Lectura columnas');

      let columns;
      try {
        columns = [
          {
            name: 'Rut Empresa',
            selector: (row) => row.rut,
            sortable: true,
            wrap: true,
            format: (row) => `${row.rut}`,
            width: "10%"
          },
           {
            name: 'Tipo documento',
            selector: (row) => row.tipoDocumento,
            sortable: true,
            wrap: true,
            format: (row) => `${row.tipoDocumento}`,
            width: "10%"
          },
          {
            name: 'Total Doc BD',
            selector: (row) => row.totalBD,
            sortable: true,
            wrap: true,
            format: (row) => `${row.totalBD}`,
            width: "10%"
          },
          {
            name: 'Total Doc S3',
            selector: (row) => row.totalS3,
            sortable: true,
            wrap: true,
            format: (row) => `${row.totalS3}`,
            width: "10%"
          },
          {
            name: 'Dif. Cant. Elementos',
            selector: (row) => row.diferencia,
            sortable: true,
            wrap: true,
            format: (row) => `${row.diferencia}`,
            width: "15%",
            compact: true
          },
          {
            name: 'Folios No Cargados en BD',
            selector: (row) => row.foliosNoCargadosEnBDCompress,
            sortable: true,
            wrap: true,
            format: (row) => `${row.foliosNoCargadosEnBDCompress}`,
            width: "15%",
            compact: true
          },
          {
            name: 'Folios Repetidos en S3',
            selector: (row) => row.foliosRepetidosCompress,
            sortable: true,
            wrap: true,
            format: (row) => `${row.foliosRepetidosCompress}`,
            width: "15%",
            compact: true
          },
          {
            name: "Acciones",
            cell: (row) => (
              <Button
                size="sm"
                className="btn-row btn-row--reprocesar"
                onClick={() => reprocesarfoliosfaltantes(row)}
              >
                Reprocesar
              </Button>
            ),
            ignoreRowClick: true,
            button: true,
          }

        ];
      } catch (error) {
        setShowErrorModal(true);
        setErrorMessage('Ocurrió un error al cargar las columnas: ' + error.message);
      }

      // console.log(' RR11 Lectura paginationComponentOptions');

      const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsText: 'Todos'
      }

      // console.log(' RR12 Lectura handleOnChangeFilterResultados');




      // console.log(' RR13 Lectura return');

      return (
        <div>
          {showContainerCheckDocsBDS3 && (
            <ContainerCheckDocsBDS3
              showTitle="Check Documentos BD/S3"
              subtitle="Compara los documentos almacenados en base de datos con los archivos en S3 para una fecha específica."
              lastcheck={data.lastcheck}
              startDate={startDate}
              handleOnChangeFilter={handleOnChangeFilter}
              busqueda={busqueda}
            />
          )}
          {showContainerResultadosCheckDocsBDS3 && (
            <ContainerResultadosCheckDocsBDS3
              showTitle="Resultados"
              filter={filter}
              handleOnChangeFilterResultados={handleOnChangeFilterResultados}
              columns={columns}
              dataFiltered={dataDisplayed}
              stats={stats}
              paginationComponentOptions={paginationComponentOptions}
              actionsMemo={actionsMemo}
            />
          )}
          {showLoading && (
            <ModalCargando
              modalTitleLoading={modalTitleLoading}
              showLoading={showLoading}
              handleClose={handleClose}
              loadingDetail={loadingDetail}
              loadingMessage={loadingMessage}
            />
          )}
          {showErrorModal && (
            <ModalError
              showTitle="Ha ocurrido un error"
              showErrorModal={showErrorModal}
              errorMessage={errorMessage}
              resetModal={handleClose}
            />
          )}
        </div>
      );
    };

  export default CheckDocsBDS3;
